export class RadioCard {
    bannerText: string;
    centerHeader: string;
    centerSubHeader: string;
    rightHeader: string;
    rightSubHeader: string;
    value: string;
    selected: boolean;
}